import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Bilan d'une classe restreint à un attendu et à ses prérequis bloquants
 * (`GET /classes/{id}/bilan-attendus/?cible=`, chantier composer-evaluation,
 * F2). Un appel par attendu affiché ; rien sans classe ni attendu (un groupe
 * n'a pas de bilan). Rend `null` tant que la réponse ne porte pas sur cette
 * classe et cet attendu (`useApi` garde l'ancienne réponse pendant un
 * chargement), et en cas d'erreur : le bandeau se tait, rien ne bloque (R12).
 */
export const useBilanCible = (idclasse, attenduId) => {
  const actif = Boolean(idclasse && attenduId);
  const { data, isError } = useApi(
    actif ? `${url}classes/${idclasse}/bilan-attendus/?cible=${attenduId}` : null,
    null,
    undefined,
    actif ? undefined : 'not-enabled',
  );
  return actif && !isError && data?.cible === attenduId && String(data?.classe_id) === String(idclasse) ? data : null;
};
